import CorrectionVehicle from './CorrectionVehicle';
export default CorrectionVehicle;
